import styled, { css } from 'styled-components';

export const HeadingContainer = styled.div<{ isBorder?: boolean; isColor?: boolean }>`
  background: #f1f1f1;
  padding: 14px 16px;
  display: flex;
  align-items: center;
  font-size: 14px;
  font-weight: bold;
  border-radius: 6px 6px 0 0;

  ${({ isBorder }) =>
    isBorder &&
    css`
      border-radius: 6px;
    `};

  ${({ isColor }) =>
    isColor &&
    css`
      background: #fff8e7;
    `};
`;

export const Icon = styled.span`
  display: inline-block;
  width: 24px;
  height: 24px;
  margin-right: 12px;
`;

export const CarefulState = styled.span`
  margin-left: auto;
`;
